export const values = state => state.formsV2.references.values;
